import { createActions } from 'redux-actions';


const actionCreators = createActions({
    AUTHOR: {
        SET: data => data,

        EDITING: {
            TOGGLE: undefined,
        },
        FETCHING: {
            ON: undefined,
            OFF: undefined,
        },
        SEARCH: {
            RESULTS: {
                SET: data => data,
                CLEAR: message => message,
            },
        },
        SET_AUTHOR_ID: author_id => author_id,
    },
});

export default actionCreators.author;
